<template>
  <el-row class="login-form">
    <el-col>
      <img class="ii-logo" src="/static/ii_logo.png" />
      <el-card class="login_card">
        <img class="client-logo" v-show="logos" :src="logos[host] || logos['insideinsight']"/>
        <el-alert v-if="message" :title="message" type="error" showicon :closable="true"></el-alert>
        <el-form label-position="top">
          <el-form-item :label="labels[0]">
            <el-input v-model="username" :placeholder="placeholders[0]"></el-input>
          </el-form-item>
          <el-form-item :label="labels[1]" v-show="!forgotPassword">
            <el-input
              :type="host === 'staples' ? 'text' : 'password'"
              :placeholder="placeholders[1]"
              v-model="password">
            </el-input>
          </el-form-item>
          <span id="hint" v-if="host === 'staples'">Replace xxxx with your Store ID</span>
          <el-form-item>
            <el-button
              type="text"
              v-if="host !== 'staples'"
              @click="forgotPassword = true"
              v-show="!forgotPassword">
              Forgot password? Click Here
            </el-button>
            <el-button type="text" @click="forgotPassword = false"
              v-show="forgotPassword">
              Return to login
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
              v-if="!forgotPassword"
              :loading="isAuthenticating"
              @click="authenticate({username, password})">
              Sign In
            </el-button>
            <div v-if="!forgotPassword && urlConfig">
              <div>OR</div>
              <el-button @click="googleAuthenticate" style="padding: 0">
                <img src="/static/G-SIGN.png" id="dagger" height="50px"/>
              </el-button>
              <el-button
                :loading="isAnonymousAuthenticating"
                @click="anonymousAuthenticate()">
                Sign In As Guest
              </el-button>
            </div>
            <el-button type="primary"
              v-if="forgotPassword"
              :loading="isSendingLink"
              @click="sendResetLink(username)">
                Send Reset Link
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
  import { mapState, mapActions } from 'vuex';

  export default {
    name: 'app-form-login',

    data() {
      return {
        host: 'insideinsight',
        labels: ['Username', 'Password'],
        placeholders: [
          'Username',
          'Password',
        ],
        username: '',
        password: '',
        forgotPassword: false,
      };
    },

    watch: {
      /**
      * Refresh credentials when route changes
      */
      $route() {
        this.refreshCredentials();
      },

      forgotPassword() {
        this.$store.commit('CLEAR_MESSAGE');
      },
    },

    computed: {
      ...mapState({
        isAuthenticating: state => state.authentication.isAuthenticating,
        isAnonymousAuthenticating: state => state.authentication.isAnonymousAuthenticating,
        isSendingLink: state => state.authentication.sendingPasswordResetLink,
        message: state => state.authentication.message,
        logos: state => state.authentication.logos,
      }),
      urlConfig() {
        return window.location.hostname.split('.').length > 1;
      },
    },

    methods: {
      ...mapActions(['authenticate', 'sendResetLink', 'fetchLogo', 'anonymousAuthenticate', 'googleAuthenticate']),
      refreshCredentials() {
        const { username, password } = this.$route.params;
        this.username = username || '';
        this.password = password || '';
      },
      updateForm(host) {
        if (host === 'staples') {
          this.placeholders = [
            'print.marketingxxxx@staples.com',
            'print.marketingxxxx@staples.com',
          ];
          this.labels = [
            'Email',
            'Confirm your email',
          ];
          this.username = 'print.marketingxxxx@staples.com';
        }
      },
    },
    // pull credentials from params
    created() {
      this.host = window.location.hostname.split('.')[0];
      this.updateForm(this.host);
      this.fetchLogo();
      this.refreshCredentials();
    },
  };
</script>

<style scoped>
  .ii-logo{
    width: 10em;
    margin: 5px auto;
    display: block;
  }
  .el-card.login_card {
    min-height: 322px;
  }
  .el-alert.el-alert--error{
    margin: 10px 0;
  }

  .client-logo {
    display: block;
    margin: 0 auto;
  }

  .el-form-item {
    margin-bottom: 10px;
  }
  .el-button--primary{
    width: 100%;
  }
  #hint {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.61);
  }
  .el-button--text{
    text-align: right;
  }

</style>



// WEBPACK FOOTER //
// LoginForm.vue?389e41f8